import { createClient } from '@supabase/supabase-js'

// NOTE: This app requires REACT_APP_SUPABASE_URL and REACT_APP_SUPABASE_ANON_KEY
// to be set as environment variables (with the REACT_APP_ prefix, as required by
// Create React App to expose vars to the browser bundle).
//
// Do NOT use Vercel's native Supabase marketplace integration — it injects vars
// without the REACT_APP_ prefix (e.g. SUPABASE_URL) which CRA cannot read at
// runtime. Instead, add the two vars manually in:
//   Vercel Dashboard → Project → Settings → Environment Variables
//
// For local development, create a .env.local file in the project root:
//   REACT_APP_SUPABASE_URL=https://<your-project>.supabase.co
//   REACT_APP_SUPABASE_ANON_KEY=eyJ...

const url = process.env.REACT_APP_SUPABASE_URL
const key = process.env.REACT_APP_SUPABASE_ANON_KEY

if (!url || !key) {
  // Surface a readable error instead of a blank screen
  document.body.style.cssText = "margin:0;background:#0f172a;display:flex;align-items:center;justify-content:center;min-height:100vh;font-family:'DM Sans',sans-serif;"
  document.body.innerHTML = `
    <div style="color:#f1f5f9;max-width:480px;padding:32px;text-align:center">
      <div style="font-size:20px;font-weight:700;color:#22d3ee;margin-bottom:16px">SpecTermite — Setup Required</div>
      <p style="color:#94a3b8;font-size:14px;line-height:1.6">
        Supabase environment variables are missing.<br><br>
        In <strong>Vercel → Project → Settings → Environment Variables</strong>, add:
      </p>
      <pre style="background:#1e293b;border-radius:8px;padding:16px;font-size:13px;text-align:left;color:#22d3ee;margin-top:16px">
REACT_APP_SUPABASE_URL=https://&lt;your-project&gt;.supabase.co
REACT_APP_SUPABASE_ANON_KEY=eyJ...</pre>
      <p style="color:#64748b;font-size:12px;margin-top:16px">
        Find these in Supabase Dashboard → Project Settings → API.<br>
        Do <em>not</em> use the Vercel native Supabase integration — it uses a
        different variable naming convention incompatible with Create React App.
      </p>
    </div>`
  throw new Error('Missing REACT_APP_SUPABASE_URL or REACT_APP_SUPABASE_ANON_KEY')
}

export const supabase = createClient(url, key)
